export const minutesAgo = (minutes: number, origin = Date.now()) => new Date(origin - minutes * 60_000).toISOString();
